import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setCrmLeadsPropertyCount } from "../../../redux/slices/filterSlice";
import Button from "../../Button/Button";
import CheckIcon from "../../../assets/svg/check-icon";

const PROPERTY_COUNT_OPTIONS = [
  { value: "1-5", label: "1 - 5" },
  { value: "6-20", label: "6 - 20" },
  { value: "21-50", label: "21 - 50" },
  { value: "51-100", label: "51 - 100" },
  { value: "101-500", label: "101 - 500" },
  { value: "501-1000", label: "501 - 1,000" },
  { value: "1001-5000", label: "1,001 - 5,000" },
  { value: "5001-10000", label: "5,001 - 10,000" },
  { value: "10001-50000", label: "10,001 - 50,000" },
  { value: "50001-100000", label: "50,001 - 1,00,000" },
];

const PropertyCountFilter = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch();
  const propertyCount = useSelector(
    (state: RootState) => state.filter.crmLeads.propertyCount
  );
  const [selected, setSelected] = useState<string>(
    (propertyCount.value as string) || ""
  );

  const handleApply = () => {
    if (selected) {
      const option = PROPERTY_COUNT_OPTIONS.find((o) => o.value === selected);
      dispatch(
        setCrmLeadsPropertyCount({
          value: selected,
          displayValue: option?.label || selected,
        })
      );
    }
    onClose();
  };

  return (
    <div className="flex flex-col gap-2 mt-2">
      <div className="flex flex-row items-center justify-between px-3">
        <h2 className="text-md text-verba-field-label dark:text-verba-field-label-dk">
          Select Range
        </h2>
      </div>
      {PROPERTY_COUNT_OPTIONS.map((option) => (
        <div
          key={option.value}
          onClick={() => setSelected(option.value)}
          className={`flex items-center justify-between p-3 mx-3 text-md gap-2 cursor-pointer border border-border-gray dark:border-border-gray-dk rounded-lg text-heading-text dark:text-heading-text-dk ${
            selected === option.value
              ? "bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk border-verba-blue dark:border-verba-blue-dk"
              : ""
          }`}
        >
          {option.label}
          <div
            className={`shrink-0 w-[14px] h-[14px] border border-gray-100 dark:border-gray-100-dk rounded-full flex items-center justify-center ${
              selected === option.value
                ? "bg-verba-blue text-pure-white dark:bg-verba-blue-dk dark:text-pure-white-dk border-verba-blue dark:border-verba-blue-dk"
                : ""
            }`}
          >
            {selected === option.value && (
              <CheckIcon className="w-3 h-3 text-pure-white dark:text-pure-white-dk" />
            )}
          </div>
        </div>
      ))}
      <div className="flex justify-end gap-2 mt-4 px-3">
        <Button
          innerText="Cancel"
          onClick={onClose}
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
        />
        <Button
          innerText="Apply"
          onClick={handleApply}
          disabled={!selected}
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </div>
  );
};

export default PropertyCountFilter;
